import { CompTypes } from '@/constants/CompTypes';
import ICompFinalProperty from './ICompFinalProperty';

export default {
    isSubject(compFinalProperty: ICompFinalProperty): boolean {
        if (compFinalProperty.compType && compFinalProperty.compType.toLowerCase() == CompTypes.Subject.toLowerCase()) {
            return true;
        }
        return false;
    }
};
